import { DEFAULT_ROW_COUNT } from "sj-ui-toolkit/src/constants/tableRowsCounts";

export interface NotificationData {
  id: number;
  title: string;
  description: string;
  author: string;
  createdAt: string;
}

export interface EditFormState {
  id: number | null;
  title: string;
  description: string;
}

export interface SkeletonRow {
  id: string;
  isSkeleton: true;
}

export type TableRow = NotificationData | SkeletonRow;

export const SKELETON_ROWS: SkeletonRow[] = Array.from({ length: DEFAULT_ROW_COUNT }, (_, i) => ({
  id: `skeleton-${i}`,
  isSkeleton: true,
}));

export const isSkeletonRow = (row: TableRow): row is SkeletonRow => "isSkeleton" in row;
